// extracted by mini-css-extract-plugin
module.exports = {"articlesContainer":"S_cw","articleItem":"S_cx","sectionSubscribe":"S_cy","imageArticle":"S_cz","info":"S_P","title":"S_S"};